import { useEffect, useState } from 'react';

/** Remember view controls for this tab, never API responses or credentials. */
export function usePilotagePreference<T extends string | number | boolean>(key: string, initial: T, allowed?: readonly T[]) {
  const storageKey = `pilotage.view.${key}`;
  const [value, setValue] = useState<T>(() => {
    try {
      const stored: unknown = JSON.parse(sessionStorage.getItem(storageKey) ?? 'null');
      if (typeof stored !== typeof initial || typeof stored === 'number' && !Number.isFinite(stored)) return initial;
      if (allowed && !allowed.includes(stored as T)) return initial;
      return stored as T;
    } catch { return initial; }
  });
  useEffect(() => { try { sessionStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* Storage may be disabled. */ } }, [storageKey, value]);
  return [value, setValue] as const;
}
